import React from 'react';
import { Link } from 'react-router-dom';
import beforeImage from '../images/me_before1.png';

function About() {
  return (
    <div className="container mx-auto p-0 md:pl-6 md:pr-0">
      <main className="max-w-3xl mx-auto p-6">
        <h1 className="text-4xl text-primary-text/70 dark:text-dark-text font-bold text-center mb-8 font-heading">Bemutatkozás</h1>
        <p className="text-lg text-primary-text/80 dark:text-dark-text mt-2 text-justify">
        A nevem Kocsis Patrik, és 2024 május 9-én (26 évesen) leukémiával diagnosztizáltak. Addig úgy éreztem, hogy minden sínen van az életemben: van egy saját lakásom, egy csodálatos menyasszonyom, egy jól fizető munkám. Rendszeresen sportoltam, és több hobbim is volt, ahol nagyszerű közösségekbe tartoztam – crossfit, darts és bowling is az életem része volt. Egyetlen nap alatt azonban minden megváltozott. Ebben a blogban megosztom a történetemet, a diagnózis pillanatától kezdve a kezeléseken át a mindennapi küzdelmekig. Nemcsak a nehézségekről írok, hanem arról is, hogyan lehet kitartani, erőt meríteni, és hogyan változtatott meg ez az egész. Tarts velem, ha szeretnél többet megtudni arról, milyen belülről megélni egy ilyen harcot, vagy netán Te is hasonló helyzetben vagy!
        </p>
        <div className="flex flex-col items-center mt-4">
          <img src={beforeImage} alt="Profile" className="mb-4" />
          <p className="text-base text-primary-text dark:text-dark-text/90 mb-4">Diagnózis előtt egy hónappal (2024 április)</p>
          <div className="flex flex-col sm:flex-row gap-4 mt-4 items-center">
            <Link to="/story/first-year">
              <button className="px-6 py-3 bg-[#5f6b6b] dark:bg-[#f2f1ed] text-white dark:text-dark-bg font-semibold rounded-lg shadow-lg hover:opacity-90 transform hover:scale-105 transition-transform duration-200 font-heading">
                Az első csata
                <span className="block text-sm font-normal opacity-90">(első év)</span>
              </button>
            </Link>
            <Link to="/story/second-year">
              <button className="px-6 py-3 bg-[#5f6b6b] dark:bg-[#f2f1ed] text-white dark:text-dark-bg font-semibold rounded-lg shadow-lg hover:opacity-90 transform hover:scale-105 transition-transform duration-200 font-heading">
                Kötéltánc
                <span className="block text-sm font-normal opacity-90">(második év)</span>
              </button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}

export default About;